/**
 * Lazyload
 * Author: Kyle Shearer
 */

var LazyLoad = (function () {

    var options = {
        lazyImage: $('.js-lazyload'),
    };

    function canInit() {

        if (options.lazyImage.length  && jQuery.fn.Lazy) {
            return true;
        }

        return false;
    }

    function init(params) {
        options = $.extend({}, options, params);

        if (canInit()) {
            console.log("hi");
            options.lazyImage.Lazy({
                scrollDirection: 'vertical',
                effect: 'fadeIn',
                afterLoad: function (element) {
                    element.fadeIn().addClass('lazyload--loaded');
                }
            });
        }
        console.log('Lazyload initialized');
    }

    return {
        init: init
    };
    
})();

$(function () {
    'use strict';
    LazyLoad.init();
});